import React from 'react';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

function Result() {
    return (
        <div className="skolkovo-kids__result">
            <div className="skolkovo-kids__result-inner">
                <div className="skolkovo-kids__result-title">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        Результаты
                    </ScrollAnimation>
                </div>
                <div className="skolkovo-kids__result-text">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        Менее чем за&nbsp;год команде агентства &laquo;Вебпрактик&raquo; удалось
                        с&nbsp;нуля сформировать на&nbsp;новой для бренда площадке сообщество
                        &laquo;Дети в&nbsp;Сколково&raquo;, привлечь в&nbsp;него более 4300
                        подписчиков за&nbsp;счет постоянного тестирования форматов
                        и&nbsp;использования внутренних возможностей социальной сети.
                    </ScrollAnimation>
                </div>
            </div>
        </div>
    );
}

export default Result;
